import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import CreateNewFolderOutlinedIcon from '@mui/icons-material/CreateNewFolderOutlined';
import { Alert, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useApiHook from "../../hooks/useApiHook";
import { useCreateFolderModal, useFolderRefresh } from "../../store/modal-context";
import ResponsiveDialog from "../_atoms/ResponsiveDialog";

const CreateFolderDialog = () => {
    const navigate = useNavigate();
    const { isOpen, closeModal } = useCreateFolderModal();
    const { refreshFolders } = useFolderRefresh();
    const { response, makeRequest, loading, error } = useApiHook();
    const [folderName, setFolderName] = useState("");
    const [submitRequested, setSubmitRequested] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setFolderName("");
            setSubmitRequested(false);
        }
    }, [isOpen]);

    useEffect(() => {
        if (!isOpen || !submitRequested || !response || response.state !== 'success') {
            return;
        }

        const createdFolderId = response.data?.id;
        refreshFolders();
        setSubmitRequested(false);
        closeModal();

        if (createdFolderId) {
            navigate(`/folder/${createdFolderId}`);
        }
    }, [closeModal, isOpen, navigate, refreshFolders, response, submitRequested]);

    const onConfirmHandler = () => {
        const trimmedFolderName = folderName.trim();
        if (!trimmedFolderName) {
            return;
        }

        setSubmitRequested(true);
        makeRequest('/folder', 'post', { name: trimmedFolderName });
    };

    return (
        <ResponsiveDialog
            minWidth="unset"
            minHeight="unset"
            title={(
                <Stack direction="row" alignItems="center" spacing={1}>
                    <CreateNewFolderOutlinedIcon fontSize="large" />
                    <Typography variant="h5">Nuova cartella</Typography>
                </Stack>
            )}
            isOpen={isOpen}
            onClose={closeModal}
            actions={(
                <>
                    <Button
                        size="large"
                        variant="contained"
                        onClick={onConfirmHandler}
                        disabled={loading || !folderName.trim()}
                    >
                        Crea
                    </Button>
                    <Button size="large" onClick={closeModal}>
                        Annulla
                    </Button>
                </>
            )}
        >
            <Stack width="100%" spacing={2}>
                <Typography width="100%" textAlign="left" variant="body2" sx={{ opacity: 0.65 }}>
                    Inserisci il nome della nuova cartella.
                </Typography>
                {error && (
                    <Alert severity="error">
                        Impossibile creare la cartella. Riprova.
                    </Alert>
                )}
                <TextField
                    autoFocus
                    fullWidth
                    label="Nome cartella"
                    value={folderName}
                    onChange={(event) => setFolderName(event.target.value)}
                />
            </Stack>
        </ResponsiveDialog>
    );
};

export default CreateFolderDialog;
